{
    "SkyraSurvey.Tittel": "Frivillig spørjeundersøking",
    "SkyraSurvey.Takk": "Takk for at du svarte på undersøkinga"
}
